'use client'
import { useSortBy, useStats } from 'react-instantsearch'
import { Select } from '@repo/web-ui/components/select/select'

export function SortingSelect({
  items,
  copy,
}: {
  items: {
    value: string
    label: string
  }[]
  copy: string
}) {
  const { nbHits, processingTimeMS } = useStats()
  const { refine, currentRefinement } = useSortBy({
    items,
  })

  const handleSort = (value: string) => {
    refine(value)
  }

  return (
    <div className="flex w-full items-center justify-between">
      <span className="text-14">
        {copy
          .replace('{nbHits}', String(nbHits))
          .replace('{processingTime}', String(processingTimeMS))}
      </span>
      <Select value={currentRefinement} onValueChange={handleSort} items={items} />
    </div>
  )
}
